import Head from 'next/head';
import React from 'react';

type PageHeadProps = {
  title?: string;
  description?: string;
  keywords?: string;
};

export const PageHead = ({
  title = process.env.APP_TITLE,
  description = process.env.APP_DESCRIPTION,
  keywords = process.env.APP_KEYWORDS,
}: PageHeadProps) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name='title' content={title} />
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
      <meta property='og:type' content='website' />
      <meta name='og:title' property='og:title' content={title} />
      <meta name='og:description' property='og:description' content={description} />
      <meta property='og:url' content={`https://ai.legalengine.co.kr/crimesearch`} />
      <meta property='og:image' content='/logo/meta_img.png' />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:creator' content='리걸엔진' />
      <meta name='twitter:image' content='/logo/meta_img.png' />
      <link rel='shortcut icon' href='/favicon.ico' />
      <link rel='icon' type='image/png' href='/favicon.ico' />
      <link rel='apple-touch-icon' href='/favicon.ico' />
    </Head>
  );
};
